import { Link } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useDeleteAbundanceEngineView } from '../../../../../api/abundanceEngine'
import SydButton from '../../../../commonDesign/Button'
import SydModal from '../../../../commonDesign/SydModal'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import DuplicateViewModal from '../AbundanceEngineListView/DuplicateViewModal'

const ViewActionsCell = ({ view, onDeleted }) => {
  const { path, viewId } = view
  const [showDuplicateModal, setShowDuplicateModal] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const { mutate, isLoading, isSuccess } = useDeleteAbundanceEngineView()

  const handleOnDelete = useCallback(() => {
    mutate(viewId)
  }, [mutate, viewId])

  useEffect(() => {
    if (isSuccess) {
      setShowDeleteConfirm(false)
      onDeleted?.()
    }
  }, [isSuccess, onDeleted])

  return (
    <div className='flex gap-2'>
      <Link
        href={'/admin/abundance-engine-views/edit/' + path}
      >
        <SydButton size='sm' icon='edit' variant='primary'>
          Edit
        </SydButton>
      </Link>

      <Link href={`/views/${path}`} target='_blank'>
        <SydButton size='sm' icon='goToDocument'>
          Go to view
        </SydButton>
      </Link>

      <SydButton
        size='sm'
        icon='fileCopy'
        variant='primary'
        onClick={() => setShowDuplicateModal(true)}
      >
        Duplicate
      </SydButton>

      <SydButton
        size='sm'
        icon='delete'
        variant='primary'
        priority='warning'
        onClick={() => setShowDeleteConfirm(true)}
      >
        Delete
      </SydButton>

      <SydModal
        disablePortal={false}
        title='Delete this view?'
        subtitle='This action cannot be undone.'
        open={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
      >
        <SydModalActions>
          <SydButton
            onClick={() => setShowDeleteConfirm(false)}
            variant='outline'
            processing={isLoading}
          >
            Cancel
          </SydButton>
          <SydButton
            onClick={handleOnDelete}
            variant='primary'
            priority='warning'
            processing={isLoading}
          >
            Delete
          </SydButton>
        </SydModalActions>
      </SydModal>

      <DuplicateViewModal
        open={showDuplicateModal}
        onClose={() => setShowDuplicateModal(false)}
        sourceView={view}
      />
    </div>
  )
}

ViewActionsCell.propTypes = {
  view: PropTypes.shape({
    path: PropTypes.string,
    viewId: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    isLive: PropTypes.bool,
    showInNavigation: PropTypes.bool,
    hideTitle: PropTypes.bool,
    disabledViewId: PropTypes.number,
    enablementCodeId: PropTypes.number,
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      displayName: PropTypes.string,
      tagId: PropTypes.number,
      viewTagId: PropTypes.number
    }))
  }),
  onDeleted: PropTypes.func
}

export default ViewActionsCell
